import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import type { VendorCtaSelectorProps } from './VendorCtaSelector';
import { CtaButton } from '../CTASection/CTASection.styles';

const ContactDealerCta = ({
  ctaDetails,
  variant,
  vehicleId,
  vehicleType,
  market,
  mainDealer,
}: VendorCtaSelectorProps) => {
  const digitalLeadsData = JSON.stringify({
    vehicleId,
    // ASK PAVEL
    vehicleType,
    market,
    presetForm: 'contact-dealer',
    dealerId: mainDealer,
  });
  const { ctaContactButtonLabel } = ctaDetails;

  return (
    <CtaButton
      type={variant}
      data-testid="contact-dealer"
      id="digital-leads"
      data-info={digitalLeadsData}
    >
      {ctaContactButtonLabel || 'Contact Dealer'}
    </CtaButton>
  );
};

export default ContactDealerCta;
